import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

// 一般及第三方匯入
import { FooterComponent } from './footer.component';

@NgModule({
	declarations: [FooterComponent],
	imports: [BrowserModule, RouterModule],
	exports: [FooterComponent],
})
export class FooterModule {}
